import { useLocation } from 'react-router-dom';

import paths from 'constants/paths';

export const useShowProgressBar = () => {
  const { pathname } = useLocation();
  return pathname.split('/').reverse()[0] !== paths.finalPage.replaceAll('/', '');
};
